import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'townip-modal-body',
  templateUrl: './modal-body.component.html',
  styleUrls: ['./modal-body.component.scss']
})
export class ModalBodyComponent implements OnInit {

  constructor() { }

  public ngOnInit(): void {
  }

}
